// frontend/src/services/flights.js
import { apiService } from './api';

export const flightsAPI = {
  async searchFlights(searchParams) {
    const params = {
      origin: searchParams.origin,
      destination: searchParams.destination,
      departure_date: searchParams.departureDate,
      passengers: searchParams.passengers,
      class_type: searchParams.classType,
    };

    if (searchParams.returnDate) {
      params.return_date = searchParams.returnDate;
    }

    return apiService.get('/flights/search', params, { skipAuth: true });
  },

  async getFlightDetails(flightId) {
    return apiService.get(`/flights/${flightId}`, {}, { skipAuth: true });
  },

  async getAirlines() {
    return apiService.get('/flights/airlines', {}, { skipAuth: true });
  },

  async getAirports() {
    return apiService.get('/flights/airports', {}, { skipAuth: true });
  }
};